interface MFAEnrollChoiceProps {
  onChoose: (wantsAuthenticator: boolean) => void;
}

// Offered once account setup is finished, at which point email is already the account's
// verification method — the code that completed the reset came from that mailbox. So this
// is not a fork between two methods; it asks whether to add an authenticator as a second
// way in. Declining is a normal outcome and finishes onboarding.
export default function MFAEnrollChoice({ onChoose }: MFAEnrollChoiceProps) {
  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-2">Add an authenticator app?</h2>
      <p className="text-gray-600 text-sm mb-6">
        Your account is set up and will send a sign-in code to your email. You can also add an
        authenticator app (Google Authenticator, Duo, and similar) as another way to sign in.
      </p>

      <div className="space-y-3">
        <button
          type="button"
          onClick={() => onChoose(true)}
          className="w-full text-left border border-gray-300 rounded-lg p-4 hover:border-blue-500 hover:bg-blue-50 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <div className="font-medium text-gray-900">Yes, set one up now</div>
          <div className="text-sm text-gray-600 mt-1">
            Scan a QR code with your authenticator app. You can then sign in with either the app or
            an emailed code.
          </div>
        </button>

        <button
          type="button"
          onClick={() => onChoose(false)}
          className="w-full text-left border border-gray-300 rounded-lg p-4 hover:border-blue-500 hover:bg-blue-50 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <div className="font-medium text-gray-900">No thanks, use email</div>
          <div className="text-sm text-gray-600 mt-1">
            Sign in with a one-time code sent to your email. You can add an authenticator later from
            your profile settings.
          </div>
        </button>
      </div>
    </div>
  );
}
